import { render, staticRenderFns } from "./uni-popup-dialog.vue?vue&type=template&id=04478c66"
import script from "./uni-popup-dialog.vue?vue&type=script&lang=js"
export * from "./uni-popup-dialog.vue?vue&type=script&lang=js"
import style0 from "./uni-popup-dialog.vue?vue&type=style&index=0&id=04478c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports